import { auth } from '../firebase/config';

const API_URL = (import.meta.env.VITE_API_BASE_URL || '') + '/api';

const getAuthToken = async () => {
    const user = auth.currentUser;
    if (!user) throw new Error("Usuario no autenticado");
    return await user.getIdToken();
};

const fetchWithAuth = async (url, options = {}) => {
    const token = await getAuthToken();
    const isFormData = options.body instanceof FormData;
    const headers = {
        'Authorization': `Bearer ${token}`,
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        ...options.headers
    };
    const response = await fetch(`${API_URL}${url}`, { ...options, headers });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error en la petición');
    }
    return response.json();
};


export const getMyCourses = async (clientId) => {
    return fetchWithAuth(`/learning/my-courses/${clientId}`);
};

export const getCourseContent = async (courseId, clientId) => {
    return fetchWithAuth(`/learning/course/${courseId}?clientId=${clientId}`);
};

export const completeLesson = async (lessonId, clientId) => {
    return fetchWithAuth(`/learning/lesson/${lessonId}/complete`, {
        method: 'POST',
        body: JSON.stringify({ clientId })
    });
};

export const submitModuleEvaluation = async (moduleId, clientId, answers) => {
    return fetchWithAuth(`/learning/module/${moduleId}/evaluate`, {
        method: 'POST',
        body: JSON.stringify({ clientId, answers })
    });
};
